import { PlanBadge, RoleBadge } from "@/components/ui-nw/UserAvatar";
import { PROFILE } from "@/constants/testIds";

export const ProfileHeader = ({ profile, avatar, actions }) => (
  <div className="relative overflow-hidden rounded-3xl border border-white/10 bg-nw-surface/70">
    <div className="h-28 sm:h-36 bg-[radial-gradient(ellipse_at_top_right,rgba(255,30,39,0.45),transparent_60%),linear-gradient(120deg,#0D0E15,#1A1D2D_50%,#0D0E15)]" />
    <div className="px-5 sm:px-8 pb-6 -mt-14 sm:-mt-16 flex flex-col sm:flex-row sm:items-end gap-4 sm:gap-6">
      {avatar}
      <div className="flex-1 min-w-0 space-y-1.5">
        <div className="flex flex-wrap gap-2">
          <RoleBadge type={profile.account_type} testId={PROFILE.role} />
          <PlanBadge tier={profile.plan_badge} />
        </div>
        <h1 data-testid={PROFILE.displayName} className="font-display text-3xl sm:text-4xl font-extrabold tracking-tight text-white truncate">{profile.display_name}</h1>
        <p data-testid={PROFILE.username} className="font-mono text-sm text-slate-400">@{profile.username}</p>
      </div>
      {actions && <div className="flex gap-2">{actions}</div>}
    </div>
    <div className="px-5 sm:px-8 pb-7">
      <p data-testid={PROFILE.bio} className="max-w-2xl text-sm sm:text-base leading-relaxed text-slate-300 whitespace-pre-line">
        {profile.bio || <span className="text-slate-500 italic">No bio yet.</span>}
      </p>
    </div>
  </div>
);
